import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

const numericRegExSpId = /^[0-9]{1,10}$/;

export const GetTestingDashboardDeleteFormSchema = (intl: IntlShape) => Yup.object({
  spId: Yup.string()
    .matches(numericRegExSpId, intl.formatMessage({ id: 'dashboard-delete-validation.spId-numeric' }))
    .required(intl.formatMessage({ id: 'dashboard-delete-validation.spId-required' })),
});

export const GetTestingDashboardDeleteFormInitialValue = (): ITestingDashboardDeleteFormFields => ({
  spId: '',
});

export interface ITestingDashboardDeleteFormFields {
  spId: string;
}
